import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { merge, Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { Option } from 'src/app/settings/model/value-field';
import { FormFieldValidator } from '../../model/form-field-element';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete-form.component.html',
  styleUrls: ['./autocomplete-form.component.scss']
})
export class AutocompleteFormComponent implements OnInit, OnDestroy {

  @Input() options: Option[];
  @Input() label: string;
  @Input() validators: FormFieldValidator[];
  @Input() controlName: string;
  @Input() parentForm: FormGroup;
  filteredOptions: Observable<Option[]>;
  private unsubscribe$: Subject<void> = new Subject();
  // Wymuszenie pełnej listy bez ruszania wartości pola - filtr liczy się z tego samego strumienia co wpisywanie.
  private showAll$: Subject<string> = new Subject();

  ngOnInit(): void {
    this.subscribeToInputChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  // Panel Materiala otwiera się na fokusie i przy pisaniu, więc po wybraniu opcji pole zostaje aktywne i kolejne
  // kliknięcie nie robiło już nic - listę dawało się przywołać dopiero zmianą tekstu albo wyjściem z pola i
  // powrotem. Przy wybranej opcji pokazujemy przy tym całą listę: filtr zawężony jej własnym tekstem zostawiłby
  // do wyboru tylko to, co już jest w polu.
  reopenPanel(trigger: MatAutocompleteTrigger): void {
    if (this.isOptionSelected()) this.showAll$.next('');
    trigger.openPanel();
  }

  private isOptionSelected(): boolean {
    const value = this.parentForm.get(this.controlName)?.value;
    return !!value && !!this.options?.some(option => option.value === value);
  }

  private subscribeToInputChanges(): void {
    const control = this.parentForm.get(this.controlName);
    if (control != null) {
      this.filteredOptions = merge(control.valueChanges, this.showAll$)
        .pipe(
          takeUntil(this.unsubscribe$),
          startWith(''),
          map(opt => opt ? this._filter(opt) : this.options.slice())
        );
    }
  }

  private _filter(key: string): Option[] {
    const filterValue = key.toLowerCase();
    return this.options.filter(option => option.key.toLowerCase().includes(filterValue));
  }
}
